import React from "react";

import { faBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faMap } from "@fortawesome/pro-solid-svg-icons/faMap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radio from "antd/es/radio";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import RadioGroup from "@app/component/input/RadioGroup";
import ViewMode, { getViewModeDisplayName } from "@app/enum/dashboard/ViewMode";

interface Props {
  onChange: (value: ViewMode) => void;
  value: ViewMode;
}

const ViewModeSelector: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();
  return (
    <RadioGroup<ViewMode> buttonStyle="solid" onChange={onChange} value={value}>
      <Tooltip placement="top" title={getViewModeDisplayName(intl, ViewMode.MAP)}>
        <Radio.Button key={ViewMode.MAP} value={ViewMode.MAP}>
          <FontAwesomeIcon icon={faMap} size="sm" />
        </Radio.Button>
      </Tooltip>
      <Tooltip placement="top" title={getViewModeDisplayName(intl, ViewMode.LIST)}>
        <Radio.Button key={ViewMode.LIST} value={ViewMode.LIST}>
          <FontAwesomeIcon icon={faBars} size="sm" />
        </Radio.Button>
      </Tooltip>
    </RadioGroup>
  );
};

export default ViewModeSelector;
